module.exports = __webpack_public_path__ + "img/icon-chart.f324b783.png";